import axios from 'axios';

const LOOKUP_URL = 'https://mvirs-lookup.brandon-560.workers.dev';
const AUTH_URL = 'https://mvirs-auth.brandon-560.workers.dev';

// ── Shop API ─────────────────────────────────────────────────────────────────

export const getShopApiUrl = async (shopId) => {
  const response = await axios.get(`${LOOKUP_URL}/shop/${shopId}`);
  return response.data.api_url;
};

export const createClient = (baseURL, token) => {
  const client = axios.create({ baseURL, timeout: 10000 });
  client.interceptors.request.use((config) => {
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return client;
};

// ── Web Auth API ──────────────────────────────────────────────────────────────

const authApi = axios.create({ baseURL: AUTH_URL, timeout: 10000 });

export const webAuth = {
  register: (data) => authApi.post('/auth/register', data),
  login: (username, password) => authApi.post('/auth/login', { username, password }),
  logout: (token) => authApi.post('/auth/logout', {}, { headers: { Authorization: `Bearer ${token}` } }),
  verifySession: (token) => authApi.get('/auth/verify-session', { headers: { Authorization: `Bearer ${token}` } }),
  verifyEmail: (token) => authApi.post('/auth/verify-email', { token }),
  forgotPassword: (email) => authApi.post('/auth/forgot-password', { email }),
  resetPassword: (token, password, confirmPassword) => authApi.post('/auth/reset-password', { token, password, confirmPassword }),
  checkUsername: (username) => authApi.get(`/auth/check-username?username=${encodeURIComponent(username)}`),
};